import { render, staticRenderFns } from "./StockTransferBlocker.vue?vue&type=template&id=614d1077"
import script from "./StockTransferBlocker.vue?vue&type=script&lang=js"
export * from "./StockTransferBlocker.vue?vue&type=script&lang=js"
import style0 from "./StockTransferBlocker.vue?vue&type=style&index=0&id=614d1077&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports